import React, { useState, useEffect } from 'react';
import {
  IN_ROOM_DINING_ITEMS_EDIT,
  IN_ROOM_DINING_ITEMS_TAB_LIST,
  IN_ROOM_DINING_MENU_VIEW,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import ItemViewDiscount from './Item-View-Discount';
import ItemsViewUpsell from './Item-View-Upsell';
import ItemTagsList from './Items-Tags-List';
import ItemAllergensList from './Items-Allergens-List';
import ItemViewAddOns from './Item-View-AddOns';
import ItemViewCustomisation from './Item-View-Customisation';
import { selectedHotelCurrencySelector } from '../../../../property/propertySlice';
import { useSelector } from 'react-redux';
import { getCurrencyNameFromCode } from '../../../../../utils/commonUtils';
import { inRoomDiningItemsSelector } from '../../../servicesSlice';

const ItemsView = (props) => {
  const {
    item,
    toggleDrawer,
    onViewToggle,
    hotelId,
    menuViewObject,
    setMenuViewObject,
    permissions,
  } = props;
  const [tabValue, setTabValue] = useState(0);
  const [selectedItem, setSelectedItem] = useState({});
  const currency = useSelector(selectedHotelCurrencySelector);
  const currencyName = getCurrencyNameFromCode(currency);
  const inRoomDiningItem = useSelector(inRoomDiningItemsSelector);

  useEffect(() => {
    if (hotelId && item.id && inRoomDiningItem.length) {
      const itemObj = {
        ...inRoomDiningItem.find((tempItemInfo) => tempItemInfo.id === item.id),
      };
      setSelectedItem(itemObj);
    }
  }, [hotelId, item, inRoomDiningItem]);

  const onClickEdit = (event) => {
    toggleDrawer(IN_ROOM_DINING_ITEMS_EDIT, true, selectedItem);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const onClickBack = () => {
    if (menuViewObject) {
      const menuObject = { ...menuViewObject };
      setMenuViewObject(null);
      onViewToggle(IN_ROOM_DINING_MENU_VIEW, true, menuObject);
    } else {
      onViewToggle(null, false, null);
    }
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Item Name</div>
                <div className='details-value preview-breaks'>{selectedItem.name}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label' style={{ marginLeft: '30Px' }}>
                  Status
                </div>
                <div align='center' className='col-md-3'>
                  <CustomChip
                    label={selectedItem.status ? 'Active' : 'Inactive'}
                    color={selectedItem.status ? 'primary' : 'default'}
                  />
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Item Code</div>
                <div className='details-value'>{selectedItem.code}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>
                  {selectedItem.description ? selectedItem.description : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Item Price</div>
                <div className='details-value'>
                  {currencyName} {selectedItem.price}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Ingredients</div>
                <div className='details-value'>
                  {selectedItem.ingredients ? selectedItem.ingredients : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <ItemAllergensList selectedItem={selectedItem} />
              </div>
              <div className='col-md-6'>
                <ItemTagsList selectedItem={selectedItem} />
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              {selectedItem?.customAttributes &&
                selectedItem?.customAttributes?.length > 0 &&
                selectedItem?.customAttributes?.map((item, index) => (
                  <div key={index} className='col-md-6 mt-4'>
                    <div className='details-label'>{item.key}</div>
                    <div className='details-value'>{item.value}</div>
                  </div>
                ))}
            </div>
          </>
        )}
        {tabValue === 1 && <ItemViewAddOns selectedItem={selectedItem} currency={currencyName} />}
        {tabValue === 2 && <ItemViewCustomisation selectedItem={selectedItem} />}
        {tabValue === 3 && <ItemsViewUpsell selectedItem={selectedItem} />}
        {tabValue === 4 && <ItemViewDiscount selectedItem={selectedItem} currency={currencyName} />}
        {tabValue === 5 && (
          <>
            <div className='row pt-4 px-3'>
              <MediaViewer
                images={selectedItem.images}
                videos={selectedItem.videos}
                gifs={selectedItem.gifs}
                enabledMediaTabs={['image']}
              />
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <>
      {selectedItem && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          onClickBack={onClickBack}
          tabValue={tabValue}
          tabList={IN_ROOM_DINING_ITEMS_TAB_LIST}
          onViewToggle={onViewToggle}
          title={selectedItem.name}
          createdUserId={selectedItem.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
        />
      )}
    </>
  );
};

export default ItemsView;
